import * as React from "react";

import { useDeviceType } from "@lululemon/ecom-site/src/util/with-device-characteristics";
import { ErrorBoundary } from "@lululemon/mwa-logger";
import { productEdHandleError } from "@lululemon/ecom-common/src/util/product-education-logger";
import {
  trackEvent,
  EVENT_CATEGORY,
  EVENT_TYPE,
} from "@lululemon/mwa-analytics";
import { WhyYouLoveThis } from "@lululemon/pdp-ee-components/src";

import useWyltData from "../../hooks/useWyltData";
import {
  useMaterialAndCare,
  useLegacyProductEducation,
} from "../../hooks/use-product-attributes";
import useVideoPlayerAnalyticsTracking from "../../hooks/use-video-player-analytics-tracking";

function WyltAdapter() {
  const wyltContentfulData = useWyltData();
  const media = wyltContentfulData?.fields?.media;
  const materialAndCare = useMaterialAndCare();
  const productEducation = useLegacyProductEducation();
  const { deviceType } = useDeviceType();

  const doubleLinedLookupKey = "light colour";

  /**
   * @TODO - Future improvement if WYLT is productized.
   * Ideally there would be a data key that would allow us to select the correct textItem from the attributes array.
   * Only TWO franchises have the double-lined call out, Align & Dance Studio
   */
  const doubleLinedText =
    productEducation
      ?.find((item) => item?.id === "fitOrIngredients")
      ?.attributes?.find((a) => a?.text?.includes(doubleLinedLookupKey))
      ?.text || "";

  const trackingInfo = {
    type: "wylt",
    text: "",
    position: -1,
    totalCount: -1,
    videoId:
      media?.fields?.title === "N/A" || !media?.fields?.title?.trim()
        ? "wylt video"
        : media?.fields?.title,
  };
  const videoRef = useVideoPlayerAnalyticsTracking(trackingInfo);

  const handleAccordionItemClick = (text, position, totalCount) => {
    trackEvent(EVENT_CATEGORY.COMPONENT_EVENT, {
      eventSubType: EVENT_TYPE.INTERACTION,
      component: {
        id: "pdp:accordion",
        type: "toggle",
        text,
        position,
        totalCount,
      },
    });
  };
  const handleStoryBlocksMobileNavigation = (text) => {
    trackEvent(EVENT_CATEGORY.COMPONENT_EVENT, {
      eventSubType: EVENT_TYPE.INTERACTION,
      component: {
        id: "pdp:accordion:slide",
        type: "CarouselOnIndexChange",
        text, // header of accordion ex. "fit" or "fabric"
        position: -1,
        totalCount: -1,
      },
    });
  };

  return (
    <ErrorBoundary
      onError={(error) =>
        productEdHandleError(error, "WhyYouLoveThis Adapter", "WYLT")
      }
    >
      <WhyYouLoveThis
        accordionItems={wyltContentfulData?.fields.accordionItems}
        description={wyltContentfulData?.fields?.description}
        doubleLinedText={doubleLinedText}
        heading={wyltContentfulData?.fields?.heading}
        intro={wyltContentfulData?.fields?.intro}
        materialAndCare={materialAndCare}
        media={media}
        deviceType={deviceType}
        videoRef={videoRef}
        handleAccordionItemClick={handleAccordionItemClick}
        handleStoryBlocksMobileNavigation={handleStoryBlocksMobileNavigation}
      />
    </ErrorBoundary>
  );
}

export default WyltAdapter;
